/* Omah Lempung theme — interactions from the V3 design. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 750px)');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* ------------------------------------------------------------------ */
  /* Toast                                                              */
  /* ------------------------------------------------------------------ */
  var toastTimer;
  function toast(html) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4200);
  }

  /* ------------------------------------------------------------------ */
  /* Reveal on scroll                                                   */
  /* ------------------------------------------------------------------ */
  var io = null;
  function scanReveal(root) {
    if (!io) return;
    $$('.rv:not([data-rv])', root || document).forEach(function (n) {
      n.setAttribute('data-rv', '1');
      io.observe(n);
    });
  }
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    if (!document.querySelector('.rv')) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
    document.body.classList.add('rv-on');
    // Anything already on screen when the page opens animates right away, no scroll needed.
    $$('.rv').forEach(function (n) {
      if (n.getBoundingClientRect().top < window.innerHeight) {
        n.setAttribute('data-rv', '1');
        n.classList.add('is-in');
      }
    });
    scanReveal();
    // Safety net: show anything still hidden that is on screen (e.g. after a layout change).
    window.addEventListener('load', function () {
      setTimeout(function () {
        $$('.rv[data-rv]:not(.is-in)').forEach(function (n) {
          if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('is-in');
        });
      }, 800);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Header: mobile drawer, dropdowns, search                           */
  /* ------------------------------------------------------------------ */
  function headerHeight() {
    var s = $('.section-header');
    if (!s) return 0;
    return getComputedStyle(s).position === 'sticky' ? s.offsetHeight : 0;
  }
  function syncStickyTop() {
    document.documentElement.style.setProperty('--sticky-top', headerHeight() + 'px');
  }

  function initHeader() {
    var toggle = $('[data-drawer-toggle]');
    var drawer = $('[data-menu-drawer]');
    function setDrawer(open) {
      if (!toggle || !drawer) return;
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (toggle) {
      toggle.addEventListener('click', function () { setDrawer(drawer.hidden); });
      $$('[data-drawer-close]', drawer).forEach(function (a) { a.addEventListener('click', function () { setDrawer(false); }); });
    }

    // Close dropdowns on outside click / Escape; one open at a time.
    document.addEventListener('click', function (e) {
      $$('details[data-dropdown][open], details[data-search-modal][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    $$('details[data-dropdown]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('details[data-dropdown][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
      // Desktop hover opens the panel too.
      d.addEventListener('mouseenter', function () { if (mqDesktop.matches && window.matchMedia('(hover: hover)').matches) d.setAttribute('open', ''); });
      d.addEventListener('mouseleave', function () { if (mqDesktop.matches && window.matchMedia('(hover: hover)').matches) d.removeAttribute('open'); });
    });

    var search = $('details[data-search-modal]');
    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) { var i = $('input[type="search"]', search); if (i) setTimeout(function () { i.focus(); }, 30); }
      });
      var close = $('[data-search-close]', search);
      if (close) close.addEventListener('click', function () { search.removeAttribute('open'); $('summary', search).focus(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('details[data-dropdown][open], details[data-search-modal][open]').forEach(function (d) {
        d.removeAttribute('open'); var s = $('summary', d); if (s) s.focus();
      });
      if (drawer && !drawer.hidden) { setDrawer(false); toggle.focus(); }
    });

    window.addEventListener('resize', function () { if (mqDesktop.matches && window.innerWidth >= 990) setDrawer(false); });
  }

  /* Localization selects submit on change */
  function initLocalization() {
    $$('form[data-localization] select').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  /* Footer accordions: open on desktop, collapsible on mobile */
  function initFooter() {
    var items = $$('[data-footer-accordion]');
    if (!items.length) return;
    function sync() { items.forEach(function (d) { if (mqDesktop.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); }); }
    sync();
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', sync);
    items.forEach(function (d) {
      $('summary', d).addEventListener('click', function (e) { if (mqDesktop.matches) e.preventDefault(); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart (AJAX add, drawer, count)                                     */
  /* ------------------------------------------------------------------ */
  var Cart = {
    drawer: function () { return $('[data-cart-drawer]'); },
    lastFocus: null,
    setCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
      $$('[data-cart-toggle]').forEach(function (a) {
        if (a.dataset.labelTemplate) a.setAttribute('aria-label', a.dataset.labelTemplate.replace('__COUNT__', count));
      });
    },
    renderDrawer: function (html) {
      var d = Cart.drawer();
      if (!d || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc);
      var current = $('[data-cart-drawer-inner]', d);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    },
    open: function () {
      var d = Cart.drawer();
      if (!d) { window.location.href = theme.routes.cart; return; }
      Cart.lastFocus = document.activeElement;
      d.hidden = false;
      document.body.style.overflow = 'hidden';
      var panel = $('.cart-drawer__panel', d);
      if (panel) panel.focus();
    },
    close: function () {
      var d = Cart.drawer();
      if (!d) return;
      d.hidden = true;
      document.body.style.overflow = '';
      if (Cart.lastFocus && Cart.lastFocus.focus) Cart.lastFocus.focus();
    },
    refreshCount: function () {
      return fetch(theme.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.setCount(c.item_count); return c; });
    },
    add: function (form, button) {
      var fd = new FormData(form);
      if (Cart.drawer()) fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      if (button) button.classList.add('is-loading');
      return fetch(theme.routes.cartAdd, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            var msg = (res.data && (res.data.description || res.data.message)) || theme.strings.error;
            var err = form.querySelector('[data-form-error]');
            if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
            return;
          }
          var err2 = form.querySelector('[data-form-error]');
          if (err2) err2.hidden = true;
          if (res.data.sections && res.data.sections['cart-drawer']) Cart.renderDrawer(res.data.sections['cart-drawer']);
          Cart.refreshCount();
          if (theme.cartType === 'drawer' && Cart.drawer()) {
            Cart.open();
          } else {
            toast(theme.strings.added + ' <a href="' + theme.routes.cart + '">→</a>');
          }
        })
        .catch(function () { toast(theme.strings.error); })
        .finally(function () { if (button) button.classList.remove('is-loading'); });
    },
    change: function (key, qty, line) {
      if (line) line.classList.add('is-busy');
      return fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c.status) { toast(c.description || theme.strings.error); if (line) line.classList.remove('is-busy'); return; }
          if (c.sections && c.sections['cart-drawer']) Cart.renderDrawer(c.sections['cart-drawer']);
          Cart.setCount(c.item_count);
        })
        .catch(function () { toast(theme.strings.error); if (line) line.classList.remove('is-busy'); });
    }
  };
  window.OLCart = Cart;

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      Cart.add(form, btn);
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var toggle = t.closest('[data-cart-toggle]');
      if (toggle && theme.cartType === 'drawer' && Cart.drawer()) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-cart-close]')) { Cart.close(); return; }
      var q = t.closest('[data-cart-qty]');
      if (q && Cart.drawer() && Cart.drawer().contains(q)) {
        var line = q.closest('[data-line-key]');
        Cart.change(line.dataset.lineKey, parseInt(q.dataset.cartQty, 10), line);
      }
    });

    document.addEventListener('keydown', function (e) {
      var d = Cart.drawer();
      if (!d || d.hidden) return;
      if (e.key === 'Escape') { Cart.close(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([disabled]), input, textarea, select, [tabindex="0"]', d).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* Quantity steppers (product + cart page) */
  function initQty(root) {
    $$('[data-qty]', root || document).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var v = clamp((parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10), min, 9999);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (wrap.hasAttribute('data-qty-autosubmit')) input.form.submit();
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Video hero                                                         */
  /* The film (with sound button) stays as it is, but it is delivered   */
  /* lighter: nothing downloads until the page has loaded, the file     */
  /* matches the screen (1080p / 720p / 480p), and it pauses when it    */
  /* is off screen so it stops using data while people browse.          */
  /* ------------------------------------------------------------------ */
  define('ol-video-hero', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.btn = $('[data-sound]', this);
      this.ready = false;
      this.visible = true;
      this.pick = this.pick.bind(this);
      this.pick();
      if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', this.pick);
      if (this.btn) this.btn.addEventListener('click', function () { self.toggleSound(); });
      if ('IntersectionObserver' in window) {
        this.vis = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.visible = e.isIntersecting;
            var v = self.current();
            if (!v) return;
            if (!e.isIntersecting) v.pause();
            else if (self.ready && !reduceMotion) self.play(v);
          });
        }, { threshold: 0.15 });
        this.vis.observe(this);
      }
    }
    disconnectedCallback() {
      if (this.vis) this.vis.disconnect();
      if (mqDesktop.removeEventListener) mqDesktop.removeEventListener('change', this.pick);
    }
    current() {
      var wrap = $(mqDesktop.matches ? '.hero__media--desktop' : '.hero__media--mobile', this);
      return wrap ? $('video', wrap) : null;
    }
    lite() {
      var c = navigator.connection || {};
      return !!(c.saveData || ['slow-2g', '2g', '3g'].indexOf(c.effectiveType) > -1);
    }
    pick() {
      var self = this;
      $$('video', this).forEach(function (v) { v.pause(); v.muted = true; });
      var v = this.current();
      if (!v) return;
      v.muted = true;
      if (this.btn) this.setLabel(false);
      if (reduceMotion) return;
      var go = function () { self.ready = true; self.begin(v); };
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', function () { setTimeout(go, 250); }, { once: true });
    }
    begin(v) {
      // Pick the file that fits: lighter on Data Saver / slow networks, 720p on smaller laptops.
      var d = v.dataset;
      var src = '';
      if (this.lite() && d.sd) src = d.sd;
      else if (mqDesktop.matches && window.innerWidth < 1600 && d.md) src = d.md;
      if (src && !d.swapped) { d.swapped = '1'; v.src = src; }
      v.preload = 'auto';
      if (this.visible) this.play(v);
    }
    play(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    setLabel(on) {
      this.btn.setAttribute('aria-pressed', String(on));
      this.btn.setAttribute('aria-label', on ? this.btn.dataset.labelOff : this.btn.dataset.labelOn);
    }
    toggleSound() {
      var v = this.current();
      if (!v) return;
      var on = v.muted;
      v.muted = !on;
      if (on && v.paused) this.play(v);
      this.setLabel(on);
    }
  });

  /* ------------------------------------------------------------------ */
  /* Collection bento filter                                            */
  /* ------------------------------------------------------------------ */
  define('ol-bento', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.chips = $$('[data-filter]', this);
      this.tiles = $$('.bento__tile', this);
      this.note = $('[data-filter-note]', this);
      this.chips.forEach(function (c) { c.addEventListener('click', function () { self.apply(c.dataset.filter); }); });
    }
    apply(f) {
      var shown = 0;
      this.chips.forEach(function (c) {
        var on = c.dataset.filter === f;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', String(on));
      });
      this.tiles.forEach(function (t) {
        var vis = f === 'all' || t.dataset.group === f;
        t.classList.toggle('is-hidden', !vis);
        if (vis) { shown++; t.classList.add('is-in'); }
      });
      if (this.note) {
        this.note.textContent = f === 'all' ? this.dataset.noteAll : this.dataset.noteSome.replace('__N__', shown);
      }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Size gallery: pinned panel, horizontal rail driven by scroll      */
  /* ------------------------------------------------------------------ */
  define('ol-size-rail', class extends HTMLElement {
    connectedCallback() {
      this.sticky = $('[data-size-sticky]', this);
      this.viewport = $('[data-size-viewport]', this);
      this.rail = $('[data-size-rail]', this);
      this.stage = $('[data-size-stage]', this);
      this.fill = $('[data-size-fill]', this);
      this.hint = $('[data-size-hint]', this);
      this.chips = $$('.chip[data-size-go]', this);
      this.dots = $$('.size__dot', this);
      this.names = this.chips.map(function (c) { return c.textContent.trim(); });
      this.count = parseInt(this.dataset.count, 10) || this.chips.length || 1;
      this.prog = 0;
      this.railMax = 0;
      this.raf = 0;
      var self = this;
      this.chips.forEach(function (b, i) {
        b.addEventListener('click', function () { self.goTo(i / self.count); });
      });
      this.dots.forEach(function (b, i) {
        b.addEventListener('click', function () { self.goTo(i / Math.max(1, self.dots.length - 1)); });
      });
      this.onScroll = function () {
        if (self.raf) return;
        self.raf = requestAnimationFrame(function () { self.raf = 0; self.update(); });
      };
      this.onResize = function () { self.layout(); self.update(); };
      this.pinned = !reduceMotion;
      if (this.pinned) {
        this.classList.add('is-pinned');
        window.addEventListener('scroll', this.onScroll, { passive: true });
      } else {
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      }
      window.addEventListener('resize', this.onResize);
      this.layout();
      this.update();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);
      window.addEventListener('load', this.onResize);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }
    layout() {
      syncStickyTop();
      this.railMax = Math.max(0, this.rail.scrollWidth - this.viewport.clientWidth);
      if (this.pinned) {
        // Track height = panel height + horizontal travel, so 1px of scroll moves the rail 1px.
        this.style.height = (this.sticky.offsetHeight + this.railMax) + 'px';
      } else {
        this.style.height = '';
      }
    }
    progress() {
      if (!this.pinned) return this.railMax ? this.viewport.scrollLeft / this.railMax : 0;
      var travel = this.offsetHeight - this.sticky.offsetHeight;
      if (travel <= 0) return 0;
      var top = this.getBoundingClientRect().top - headerHeight();
      return clamp(-top / travel, 0, 1);
    }
    update() {
      var p = this.progress();
      this.prog = p;
      if (this.pinned) this.rail.style.transform = 'translate3d(' + (-Math.round(this.railMax * p)) + 'px,0,0)';
      var idx = Math.min(this.count - 1, Math.round(p * this.count));
      var dotIdx = Math.min(this.dots.length - 1, Math.round(p * (this.dots.length - 1)));
      this.chips.forEach(function (c, i) {
        var on = i === idx;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-current', on ? 'step' : 'false');
      });
      this.dots.forEach(function (d, i) {
        var on = i === dotIdx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-current', on ? 'step' : 'false');
      });
      if (this.stage && this.names[idx]) this.stage.textContent = this.names[idx];
      if (this.fill) this.fill.style.width = Math.round(p * 100) + '%';
      if (this.hint) this.hint.classList.toggle('is-gone', p > 0.04);
    }
    goTo(p) {
      p = clamp(p, 0, 1);
      if (!this.pinned) {
        this.viewport.scrollTo({ left: this.railMax * p, behavior: 'smooth' });
        return;
      }
      var travel = this.offsetHeight - this.sticky.offsetHeight;
      var top = this.getBoundingClientRect().top + window.scrollY - headerHeight();
      window.scrollTo({ top: top + travel * p + 1, behavior: 'smooth' });
    }
  });

  /* ------------------------------------------------------------------ */
  /* Shop the room hotspots                                             */
  /* ------------------------------------------------------------------ */
  define('ol-hotspots', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.spots = $$('[data-hotspot]', this);
      this.cards = $$('[data-hotspot-card]', this);
      this.spots.forEach(function (s) {
        $('.hotspot__dot', s).addEventListener('click', function () { self.toggle(s); });
      });
      document.addEventListener('click', function (e) {
        if (!mqDesktop.matches) return;
        if (!self.contains(e.target)) self.closeAll();
      });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeAll(true); });
      if (!mqDesktop.matches && this.spots[0]) this.mark(this.spots[0], true);
    }
    mark(s, open) {
      var b = $('.hotspot__dot', s);
      s.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', String(open));
      b.setAttribute('aria-label', open ? b.dataset.labelHide : b.dataset.labelShow);
      var pop = $('.hotspot__pop', s);
      if (pop) pop.hidden = !open || !mqDesktop.matches;
    }
    closeAll(focus) {
      var self = this;
      this.spots.forEach(function (s) {
        if (focus && s.classList.contains('is-open')) $('.hotspot__dot', s).focus();
        self.mark(s, false);
      });
    }
    toggle(s) {
      var self = this;
      var idx = s.dataset.hotspot;
      if (mqDesktop.matches) {
        var open = !s.classList.contains('is-open');
        this.spots.forEach(function (o) { self.mark(o, o === s ? open : false); });
      } else {
        this.spots.forEach(function (o) { self.mark(o, o === s); });
        this.cards.forEach(function (c) { c.hidden = c.dataset.hotspotCard !== idx; });
      }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Product carousel                                                   */
  /* ------------------------------------------------------------------ */
  define('ol-carousel', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = $('[data-carousel-track]', this);
      this.prev = $('[data-carousel-prev]', this);
      this.next = $('[data-carousel-next]', this);
      this.label = $('[data-carousel-label]', this);
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(1); });
      this.track.addEventListener('scroll', function () { self.sync(); }, { passive: true });
      window.addEventListener('resize', function () { self.sync(); });
      this.sync();
    }
    step() {
      var item = this.track.firstElementChild;
      if (!item) return this.track.clientWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      var per = Math.max(1, Math.floor((this.track.clientWidth + gap) / (item.offsetWidth + gap)));
      return per * (item.offsetWidth + gap);
    }
    go(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }
    sync() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var x = this.track.scrollLeft;
      var step = this.step();
      var pages = Math.max(1, Math.ceil(max / step) + 1);
      var page = max <= 0 ? 1 : Math.min(pages, Math.round(x / step) + 1);
      if (x >= max - 4) page = pages;
      if (this.label) this.label.textContent = page + ' / ' + pages;
      if (this.prev) this.prev.disabled = x <= 4;
      if (this.next) this.next.disabled = x >= max - 4;
    }
  });

  /* ------------------------------------------------------------------ */
  /* Product page: variants, gallery, WhatsApp order link              */
  /* ------------------------------------------------------------------ */
  define('ol-product', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var json = $('[data-product-json]', this);
      this.data = json ? JSON.parse(json.textContent) : null;
      this.form = $('form[data-product-form]', this);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.addBtn = $('[data-add-button]', this);
      this.priceEl = $('[data-price]', this);
      this.skuEl = $('[data-sku]', this);
      this.wa = $('[data-wa-order]', this);
      this.qtyInput = $('input[name="quantity"]', this);
      this.main = $('[data-gallery-main]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.counter = $('[data-gallery-counter]', this);

      $$('.option__input', this).forEach(function (i) { i.addEventListener('change', function () { self.onOptionChange(); }); });
      if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.updateWa(); });
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.showSlide(i); }); });
      if (this.main) this.main.addEventListener('scroll', function () { self.syncThumbs(); }, { passive: true });
      if (this.data) { this.current = this.findVariant(this.selected()) || this.data.variants[0]; this.updateAvailability(); }
      this.updateWa();
    }
    selected() {
      return $$('fieldset.option', this).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    findVariant(opts) {
      if (!this.data) return null;
      return this.data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }
    onOptionChange() {
      $$('fieldset.option', this).forEach(function (fs) {
        var c = $('input:checked', fs), out = $('[data-option-selected]', fs);
        if (c && out) out.textContent = c.value;
      });
      var v = this.findVariant(this.selected());
      this.current = v;
      this.updateAvailability();
      if (!v) {
        this.setButton(false, theme.strings.unavailable);
        this.updateWa();
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      if (this.priceEl) this.priceEl.innerHTML = v.price_html;
      if (this.skuEl) { this.skuEl.textContent = v.sku || ''; this.skuEl.hidden = !v.sku; }
      this.setButton(v.available, v.available ? theme.strings.addToCart : theme.strings.soldOut);
      if (v.media_id) {
        var idx = this.slideIndexForMedia(v.media_id);
        if (idx > -1) this.showSlide(idx);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      this.updateWa();
    }
    updateAvailability() {
      // Mark option values that cannot form an available variant with the other current selections.
      if (!this.data) return;
      var self = this;
      var sel = this.selected();
      $$('fieldset.option', this).forEach(function (fs, pos) {
        $$('.option__input', fs).forEach(function (input) {
          var trial = sel.slice();
          trial[pos] = input.value;
          var v = self.findVariant(trial);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    setButton(enabled, label) {
      if (!this.addBtn) return;
      this.addBtn.setAttribute('aria-disabled', String(!enabled));
      this.addBtn.disabled = !enabled;
      var l = $('[data-add-label]', this.addBtn);
      if (l) l.textContent = label;
    }
    slideIndexForMedia(id) {
      if (!this.main) return -1;
      var slides = $$('[data-media-id]', this.main);
      for (var i = 0; i < slides.length; i++) if (String(slides[i].dataset.mediaId) === String(id)) return i;
      return -1;
    }
    showSlide(i) {
      if (!this.main) return;
      var slide = this.main.children[i];
      if (!slide) return;
      this.main.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.markThumb(i);
    }
    syncThumbs() {
      var w = this.main.clientWidth || 1;
      this.markThumb(Math.round(this.main.scrollLeft / w));
    }
    markThumb(i) {
      this.thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.main.children.length;
    }
    updateWa() {
      if (!this.wa || !this.data) return;
      var v = this.current;
      var qty = this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
      var lines = [this.data.wa_intro, ''];
      var name = this.data.title + (v && !this.data.single ? ' (' + v.title + ')' : '');
      lines.push('• ' + name);
      lines.push(this.data.wa_qty + ': ' + qty);
      if (v && v.price_text) lines.push(this.data.wa_price + ': ' + v.price_text);
      if (v && v.sku) lines.push('SKU: ' + v.sku);
      lines.push(this.data.url + (v ? '?variant=' + v.id : ''));
      this.wa.href = this.data.wa_base + '?text=' + encodeURIComponent(lines.join('\n'));
    }
  });

  /* Product recommendations, loaded after the page */
  define('ol-recs', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.children.length || !this.dataset.url) return;
      var load = function () {
        fetch(self.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('ol-recs');
          if (fresh && fresh.innerHTML.trim()) {
            self.innerHTML = fresh.innerHTML;
            $$('.rv', self).forEach(function (n) { n.classList.add('is-in'); });
          }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var ob = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { ob.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        ob.observe(this);
      } else { load(); }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Collection: sort + filter forms                                    */
  /* ------------------------------------------------------------------ */
  function initFacets() {
    $$('[data-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { el.form.submit(); });
    });
    var panel = $('details[data-facets]');
    if (panel) {
      document.addEventListener('click', function (e) { if (panel.open && !panel.contains(e.target)) panel.removeAttribute('open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.open) { panel.removeAttribute('open'); $('summary', panel).focus(); } });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                               */
  /* ------------------------------------------------------------------ */
  function boot() {
    syncStickyTop();
    initReveal();
    initHeader();
    initLocalization();
    initFooter();
    initCart();
    initQty();
    initFacets();
    window.addEventListener('resize', syncStickyTop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    scanReveal(e.target);
    $$('.rv', e.target).forEach(function (n) { n.classList.add('is-in'); });
    initQty(e.target);
    initLocalization();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var spot = e.target.closest && e.target.closest('[data-hotspot]');
    if (spot) { var host = spot.closest('ol-hotspots'); if (host) host.toggle(spot); }
  });
})();
